module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "\n<div class=\"quote-full-wrapper\">\n    <div class=\"quotes quotes-large\" aria-hidden=\"true\"></div>\n    <blockquote data-en=\"";
  stack1 = depth0.quote;
  stack1 = stack1 == null || stack1 === false ? stack1 : stack1.eng;
  stack1 = typeof stack1 === functionType ? stack1() : stack1;
  buffer += escapeExpression(stack1) + "\" data-fr=\"";
  stack1 = depth0.quote;
  stack1 = stack1 == null || stack1 === false ? stack1 : stack1.fra;
  stack1 = typeof stack1 === functionType ? stack1() : stack1;
  buffer += escapeExpression(stack1) + "\"></blockquote>\n</div>";
  return buffer;});